import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import ConditionedComponent from 'components/ConditionedComponent.js';
import React, { Component } from 'react';
import { Badge} from 'reactstrap';
import Dropdown from 'react-dropdown'

class ConnectToUserModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            guilds: [],
            selectedGuild: undefined,
            ownUserName: ''

        }

        this.fetchUserName();
        this.fetchGuilds();
    }


    async fetchUserName() {
        let userName = await this.props.ethereum.users.getUserName(this.state.userId);
        this.setState({ownUserName: userName});
    }

    async fetchGuilds() {
        let guilds = await this.props.guilds.getGuildsForUser();
        this.setState({guilds: guilds});
    }

    getGuildsOptions() {
        let options = this.state.guilds
            .map(x => ({label: x.name, value: x.guildId}));

        return options;
    }

    onSelectGuild(option) {
        this.setState({selectedGuild: option});
    }

    getSelectedGuild() {
        return this.state.selectedGuild;
    }

    connectWithUser() {
        if (this.state.selectedGuild !== undefined) {
            this.props.guilds.requestToAddMember(this.state.selectedGuild.value, this.props.userId);
        } else {
            this.props.guilds.connectWithUser(this.props.userId);
        }
        this.props.hide();
    }

    render() {
        let name = this.props.preset !== undefined ? this.props.preset.name : '';
        return (
            <Modal dialogClassName="preset-modal" show={this.props.show} onHide={this.props.hide}>
              <Modal.Header closeButton>
                <Modal.Title>Connect with {this.props.userName}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ConditionedComponent condition={this.state.guilds.length > 0}>
                <Dropdown
                  className=''
                  options={this.getGuildsOptions()}
                  onChange={(o) => this.onSelectGuild(o)}
                  value={this.getSelectedGuild()}
                  placeholder="Choose guild to connect via" />
                </ConditionedComponent>
                Send a request to link up to your {this.state.ownUserName} account.
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => this.connectWithUser()}>
                  Ok
            </Button>
                <Button variant="primary" onClick={this.props.hide}>
                  Cancel 
            </Button>
                </Modal.Footer>
                </Modal>
        );
   }
}

export default ConnectToUserModal;
